import script from "./org.vue?vue&type=script&setup=true&lang=js"
export * from "./org.vue?vue&type=script&setup=true&lang=js"

import "./org.vue?vue&type=style&index=0&id=73af23d2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73af23d2"]])

export default __exports__